import React, { Component, ChangeEvent } from "react";
import ErrorTip from "../errorTip";
import { fetchCode } from "../../services/services";
import { getQueryString } from "../../utils/utils";
import { burying } from "../../utils/buryPoint";
import styles from "./index.less";

interface Props {
  is_required?: boolean; // 是否必填
  phoneInfo?: any; //手机号是否必填
  codeInfo?: any; //验证码是否必填
  code?: boolean; //是否要验证码
  contactGray?: boolean; //提交数据后不可点击
  type?: string;
  codeError?: string;
  phoneError?: string;
  grayType?: boolean;
  onPhone?: (value: string) => void; //手机Input
  onCode?: (value: string) => void; //验证码Input
  checkMessage?: () => void;
  onblur?: () => void;
  onfocus?: () => void;
  getValue?: (value: any, type: string) => void; //申诉获取value方法
  getCode?: (codeNumber: string) => void;
  inputClick?: (type: string) => void; //点击输入框
}

interface State {
  phoneNum: string;
  codeNum: string;
  phoneStyle: boolean;
  codeStyle: boolean;
  phoneTip: string;
  codeTip: string;
  countType: boolean;
  codeSuc: boolean;
  codeTxt: string;
  count: number;
}

const regPhoneNum = /^1[3456789]\d{9}$/; // 手机号
const reg = /^[0-9]*$/;
const spaceReg = /\s/g;
let timeOut: any;

class VerificationCode extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      phoneNum: "",
      codeNum: "",
      phoneStyle: false,
      codeStyle: false,
      phoneTip: "",
      codeTip: "",
      countType: false,
      codeSuc: false,
      codeTxt: "获取验证码",
      count: 60,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { grayType } = nextProps;
    if (grayType) {
      this.setState({
        phoneNum: "",
        codeNum: "",
      });
    }
  }

  /**
   * @description 手机号校验
   *
   **/
  phoneInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { getValue, phoneInfo, onPhone, checkMessage, type } = this.props;
    const value = e.target.value;
    const Text = value.replace(spaceReg, "");
    const filter = Text.substring(0, 11);
    onPhone ? onPhone(filter) : "";
    getValue ? getValue(filter, phoneInfo.fieldName) : "";
    type == "sp" ? checkMessage() : "";
    if (reg.test(filter)) {
      this.setState({
        phoneTip: "",
        phoneNum: filter,
      });
      !regPhoneNum.test(filter)
        ? this.setState({ codeStyle: false })
        : this.setState({ codeStyle: true });
    } else if (value !== "") {
      this.setState({
        phoneTip: "请输入手机号码",
      });
    } else {
      this.setState({
        phoneNum: filter,
      });
    }
  };

  /**
   * @description 验证码校验
   *
   **/
  codeInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { getValue, codeInfo, onCode, checkMessage, type } = this.props;
    const value = e.target.value;
    const Text = value.replace(spaceReg, "");
    const filter = Text.substring(0, 6);
    onCode ? onCode(filter) : "";
    getValue ? getValue(filter, codeInfo.fieldName) : "";
    type == "sp" ? checkMessage() : "";
    if (reg.test(filter)) {
      this.setState({
        codeTip: "",
        codeNum: filter,
      });
    } else if (value !== "") {
      this.setState({
        codeTip: "请输入数字",
      });
    } else {
      this.setState({
        codeNum: filter,
      });
    }
  };

  /**
   * @description 倒计时方法
   *
   **/
  countDown = (number: number) => {
    if (number === 0) {
      this.setState({
        countType: false,
        codeStyle: true,
        count: 60,
        codeTxt: "重新发送",
      });
    } else {
      timeOut = setTimeout(async () => {
        await this.setState({ count: number - 1 });
        this.countDown(number - 1);
      }, 1000);
    }
  };

  /**
   * @description 获取验证码方法
   *
   **/
  getCodeFunc = async () => {
    const { checkMessage, type } = this.props;
    const { phoneNum, codeStyle, count } = this.state;
    const spTemplateId = getQueryString("spTemplateId");
    const templateId = getQueryString("templateId");
    const punishId = getQueryString("punishId");
    type == "sp" ? checkMessage() : "";
    if (phoneNum !== "") {
      if (!regPhoneNum.test(phoneNum)) {
        this.setState({
          phoneTip: "请输入正确的手机号",
        });
      } else if (codeStyle) {
        type === "sp"
          ? burying(
              "2",
              "verifycode-appeal-submit",
              "undefined",
              "ss-03",
              "undefined"
            )
          : burying(
              "2",
              "code-appeal-submit",
              `punishid=${punishId}`,
              "ss-03",
              "undefined"
            );
        this.setState({
          codeStyle: false,
          countType: true,
        });
        this.countDown(count);
        const param = {
          phone: phoneNum,
          spTemplateId,
          templateId: templateId == "undefined" ? "" : templateId,
        };
        const result = await fetchCode(param);
        if (
          result &&
          result.code !== undefined &&
          result.code.toString() === "0"
        ) {
          // getCode('1')
          return;
        } else {
          clearTimeout(timeOut);
          this.setState({
            countType: false,
            codeStyle: true,
            count: 60,
            codeTxt: "重新发送",
          });
        }
      }
    } else {
      this.setState({
        phoneTip: "请输入手机号",
      });
    }
  };

  /**
   * @description 渲染手机号输入框
   *
   **/
  renderPhoneInput = () => {
    const { showName, required, showTips } = this.props.phoneInfo;
    const { phoneNum, phoneTip } = this.state;
    const { type, phoneError, grayType } = this.props;
    const punishId = getQueryString("punishId");
    return (
      <div className={styles.phoneInput}>
        {required ? <span className={styles.star}>*</span> : null}
        <span className={styles.showName}>{showName}：</span>
        <input
          value={phoneNum}
          placeholder={showTips}
          onChange={this.phoneInputChange}
          style={{ width: type === "sp" ? "320px" : null }}
          disabled={grayType}
          onClick={() => {
            type === "sp"
              ? burying(
                  "2",
                  "verify-appeal-submit",
                  "frame=0",
                  "ss-03",
                  "undefined"
                )
              : burying(
                  "2",
                  "write-appeal-submit",
                  `frame=2$punishid=${punishId}`,
                  "ss-03",
                  "undefined"
                );
          }}
        />
        {phoneTip || phoneError ? (
          <div className={styles.ErrorTip}>
            <ErrorTip errorTip={phoneTip ? phoneTip : phoneError} />
          </div>
        ) : null}
      </div>
    );
  };

  /**
   * @description 渲染验证码输入框
   *
   **/
  renderCodeInput = () => {
    const { showName, required, showTips } = this.props.codeInfo;
    const { type, codeError, grayType } = this.props;
    const {
      codeNum,
      codeTip,
      countType,
      codeTxt,
      count,
      codeStyle,
    } = this.state;
    const punishId = getQueryString("punishId");
    return this.props.code ? (
      <div className={styles.codeInput}>
        {required ? <span className={styles.star}>*</span> : null}
        <span className={styles.showName}>{showName}：</span>
        <input
          value={codeNum}
          placeholder={showTips}
          onChange={this.codeInputChange}
          style={{ width: type === "sp" ? "212px" : null }}
          disabled={grayType}
          onClick={() => {
            type === "sp"
              ? burying(
                  "2",
                  "verify-appeal-submit",
                  "frame=1",
                  "ss-03",
                  "undefined"
                )
              : burying(
                  "2",
                  "write-appeal-submit",
                  `frame=3$punishid=${punishId}`,
                  "ss-03",
                  "undefined"
                );
          }}
        />
        <span
          className={styles.CodeTxt}
          style={{ pointerEvents: grayType ? "none" : null }}
          onClick={this.getCodeFunc}
        >
          {countType ? (
            <span
              className={styles.count}
              style={{ width: type === "sp" ? "90px" : null }}
            >
              {count}s
            </span>
          ) : (
            <span
              className={codeStyle ? styles.count : styles.codeTxt}
              style={{ width: type === "sp" ? "90px" : null }}
            >
              {codeTxt}
            </span>
          )}
        </span>
        {codeTip || codeError ? (
          <div className={styles.ErrorTip}>
            <ErrorTip errorTip={codeTip ? codeTip : codeError} />
          </div>
        ) : null}
      </div>
    ) : null;
  };

  render() {
    return (
      <div className={styles.verificationCode}>
        {this.renderPhoneInput()}
        {this.renderCodeInput()}
      </div>
    );
  }
}

export default VerificationCode;
